import React from 'react';
import { Content } from '../../../../../CommonComponents/OPL/StickyFooter/StickyFooter';
import { StepCard } from '../StepCard/StepCard';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { ScrollHereOnce } from '../../../../../CommonComponents/ScrollHereOnce';
import { Alert } from '../../../../../CommonComponents/OPL/Alert/Alert';
import { CARDS_WIDTH } from '../../CharitableGiving.meta';

interface Props {
  title: React.ReactNode;
  children: React.ReactNode;
  footer: React.ReactNode;
  alert?: string;
  onSubmit(v: any): void;
}

export const StepContainer = ({ title, children, footer, onSubmit, alert }: Props) => {
  return (
    <>
      <ScrollHereOnce options={false} />

      <Box as="form" minWidth={500} mt={96} onSubmit={onSubmit}>
        <Content>
          <Box maxWidth={CARDS_WIDTH} mx="auto" mb="32">
            {alert && <Alert variant="warning" message={alert} />}
          </Box>

          <StepCard>
            <Text color="neutral.700" fontSize="h3" fontWeight={500} mb="32">
              {title}
            </Text>

            <Box>{children}</Box>
          </StepCard>
        </Content>

        {footer}
      </Box>
    </>
  );
};
